import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding: 32px 0px;
  flex-wrap: wrap;
`;
